import React, { useEffect, useRef } from "react";
import { Container } from "react-bootstrap";
import { connect } from "react-redux";
import { getGradeList } from "../../actions/Grade.action";
import { clearIndividualTerminalAssessment } from "../../actions/IndividualTerminalAssessment.action";
import IndividualTerminalAssessmentForm from "../../components/IndividualTerminalAssessmentForm";
import StudentView from "../../components/IndividualTerminalAssessmentForm/StudentView";
import PublicLayout from "../../components/shared/PublicLayout/PublicLayout";
import TerminalMarksTable from "../../components/TerminalMarksTable";
import TerminalSummaryTable from "../../components/TerminalSummaryTable";

const PublicIndividualTerminalAssessmentPage = ({
  individualTerminalAssessment,
  clearIndividualTerminalAssessment,
  getGradeList,
  grades,
}) => {
  const ref = useRef(null);

  useEffect(() => {
    getGradeList();
  }, [getGradeList]);

  const handleClearData = () => {
    clearIndividualTerminalAssessment();
  };

  return (
    <div className="bg_light">
      <PublicLayout title="Individual Terminal Assessment">
        <Container>
          <IndividualTerminalAssessmentForm grades={grades} publicView={true} />

          {individualTerminalAssessment.assessment &&
            individualTerminalAssessment.assessment.success && (
              <div className="mt-4">
                <div ref={ref}>
                  {/* Student Information Section */}
                  {individualTerminalAssessment.assessment.student && (
                    <div className="pt-4 pb-3">
                      <div className="">
                        <StudentView
                          data={individualTerminalAssessment.assessment}
                          response={individualTerminalAssessment.assessment}
                        />
                      </div>
                    </div>
                  )}

                  <TerminalMarksTable
                    data={individualTerminalAssessment.assessment.data}
                    term={individualTerminalAssessment.assessment.extra?.term}
                    year={individualTerminalAssessment.assessment.extra?.year}
                  />

                  <TerminalSummaryTable
                    summary={individualTerminalAssessment.assessment.summary}
                    student={individualTerminalAssessment.assessment.student}
                  />
                </div>
              </div>
            )}

          {individualTerminalAssessment.loading && (
            <div className="text-center py-4">
              <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p className="mt-2">Loading assessment data...</p>
            </div>
          )}
        </Container>
      </PublicLayout>
    </div>
  );
};

const mapStateToProps = (state) => ({
  individualTerminalAssessment: state.individualTerminalAssessment,
  grades: state.grade.grade,
});

const mapDispatchToProps = {
  clearIndividualTerminalAssessment,
  getGradeList,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PublicIndividualTerminalAssessmentPage);
